// extracted by mini-css-extract-plugin
export default {"NotFound":"_404_NotFound__-z23Z","content":"_404_content__LZVbj","P":"_404_P__mrDjw","H1":"_404_H1__DJJFp","buttons":"_404_buttons__D3UJt"};